
import { Prop, Watch, Component, Vue } from "vue-property-decorator";
import debounce from "debounce";
import { TranslateResult } from "vue-i18n";

@Component({})
export default class MylobyAutocompleteMultiple extends Vue {

  @Prop({ default: async () => ({ count: 0, rows: [] }) })
  public fetchQuery: ({ search, page, itemsPerPage }: { search: string, page?: number, itemsPerPage?: number },
  ) => Promise<{ count: number; rows: any[] }>;

  @Watch("search", { immediate: false })
  public handlerSearch = debounce(this.getFirstItems, 500);

  @Prop({ default: () => "name" })
  public itemTextFn: (item: any) => string;

  @Prop({ default: false })
  public disabled: boolean;

  @Prop()
  private value!: any[];

  @Prop()
  private label: TranslateResult;

  @Prop()
  private prependInnerIcon: string;

  private items: any[] = [];
  private selected: any[] = [];
  private search: string = "";
  private loading: boolean = false;
  private page: number = 1;
  private itemsPerPage: number = 10;
  private totalCount: number = 0;

  @Watch("value")
  public handlerValue() {
      this.selected = this.value;
  }

  private async mounted(): Promise<void> {
    await this.getFirstItems();
  }

  private clear(): void {
    this.selected = [];
    this.setModel();
  }

  private setModel() {
    this.$emit("input", this.selected);
  }

  private async getFirstItems(): Promise<void> {
    this.page = 1;
    this.items = [];
    await this.fetchData();
  }

  private async getNextItems() {
    this.page++;
    await this.fetchData();
  }

  private async fetchData() {
    this.loading = true;
    await this.fetchQuery({ search: this.search, page: this.page, itemsPerPage: this.itemsPerPage })
      .then((data) => {
        this.items = [
          ...this.items,
          ...data.rows.map((row) => {
            const match = this.selected?.find((selectedItem) => selectedItem.id === row.id);
            return match || row;
          }),
          ...this.selected.filter(
            (selectedItem) => !this.items.some((row) => row.id === selectedItem.id),
          ),
        ];
        this.totalCount = data.count;
      }).catch((err) => {
        this.$store.commit("alerts/displayError", {
          msg: err,
        });
      }).finally(() => {
        this.loading = false;
      });
  }

}
